<template>
  <div>
    <div align="left">
      <br />
      <b-row>
        <b-col md="4">
          <h5 class="font-weight-bold text-primary">Profil Keanggotaan</h5>
        </b-col>
        <b-col md="2">
          <b-button block variant="danger">Keluar Dari Grup</b-button>
        </b-col>
      </b-row>
      <br />
    </div>
    <b-row>
      <b-col md="6">
        <b-card class="text-left">
          <b-row class="mt-4">
            <b-col md="12">
              <b-form-group
                id="fieldset-1"
                label="Nama Usaha"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required|numeric'"
                  v-model="phone_number"
                  name="phone_number"
                  data-vv-as="Phone Number"
                  id="input-1"
                  class="form-control"
                  placeholder="Phone Number"
                />
                <b-form-invalid-feedback
                  id="input-phone_number-feedback"
                >{{ veeErrors.first('phone_number') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                id="fieldset-1"
                label="Jenis Usaha"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required|email'"
                  v-model="email_address"
                  name="email_address"
                  data-vv-as="Email Address"
                  class="form-control"
                  placeholder="Email Address"
                />
                <b-form-invalid-feedback
                  id="input-email_address-feedback"
                >{{ veeErrors.first('email_address') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                id="fieldset-1"
                label="Alamat Usaha"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required|email'"
                  v-model="email_address"
                  name="email_address"
                  data-vv-as="Email Address"
                  class="form-control"
                  placeholder="Email Address"
                />
                <b-form-invalid-feedback
                  id="input-email_address-feedback"
                >{{ veeErrors.first('email_address') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-right">
            <b-col md="4" class="text-left">
              <label class="text-danger">
                *
                <b class="text-dark">Required</b>
              </label>
            </b-col>
            <b-col></b-col>
          </b-row>
        </b-card>
        <br />
        <b-button variant="primary" :disabled="loading" class="mr-3" block size="lg">
          Create
          <b-spinner v-if="loading" small label="Loading..."></b-spinner>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      phone_number: null,
      email_address: null
    };
  },
  methods: {
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("phone", this.phone_number);
          formData.append("email", this.email_address);
          this.$store
            .dispatch("GeneralSettingsModule/postContactUs", formData)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "GeneralContactUs" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your file cant be submit.", "warning");
        }
      });
    },
    onChangeimage() {
      this.image = this.$refs.image.files[0];
      const input = this.$refs.image;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>
